<ng-container *ngIf="!!groupedModifiers && groupedModifiers.length > 0">
    <ng-container *ngFor="let group of groupedModifiers">
        <ng-container *ngFor="let modifier of group.modifiers">
            <ion-row *ngIf="modifier.menuModifier.name !== toppingGroupName">
                <ion-col size-xs="9" size-md="10" [style]="childStyle">
                    <div class="line-item-container">
                        <div class="line-item-name">{{ modifier.menuModifier.name }}</div>
                        <div *ngIf="!hideTotal && !!modifier.additionalPrice"
                             class="line-item-price"
                             [class.remove-padding]="removePadding"
                             [class.canceled-price]="orderStatus === orderStatuses.CANCELED">
                            {{ adjustedPrice(modifier.additionalPrice) | currency }}
                        </div>
                    </div>
                </ion-col>
            </ion-row>
        </ng-container>
    </ng-container>
</ng-container>


